/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionLeadScreenerLeadInfoRace
 */
export interface PalAuthSubmissionLeadScreenerLeadInfoRace {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    name?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionLeadScreenerLeadInfoRace interface.
 */
export function instanceOfPalAuthSubmissionLeadScreenerLeadInfoRace(value: object): value is PalAuthSubmissionLeadScreenerLeadInfoRace {
    return true;
}

export function PalAuthSubmissionLeadScreenerLeadInfoRaceFromJSON(json: any): PalAuthSubmissionLeadScreenerLeadInfoRace {
    return PalAuthSubmissionLeadScreenerLeadInfoRaceFromJSONTyped(json, false);
}

export function PalAuthSubmissionLeadScreenerLeadInfoRaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionLeadScreenerLeadInfoRace {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function PalAuthSubmissionLeadScreenerLeadInfoRaceToJSON(json: any): PalAuthSubmissionLeadScreenerLeadInfoRace {
    return PalAuthSubmissionLeadScreenerLeadInfoRaceToJSONTyped(json, false);
}

export function PalAuthSubmissionLeadScreenerLeadInfoRaceToJSONTyped(value?: PalAuthSubmissionLeadScreenerLeadInfoRace | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

